import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const FlexerParentMaxHeightStyled = styled(Flexer.Parent)`
  height: 100%;
`;

export default FlexerParentMaxHeightStyled;
